import React from 'react';
import { Link } from 'react-router-dom';
import { Button, makeStyles, Icon } from '@material-ui/core';

const Contact = () => {
  const useStyles = makeStyles(theme => ({
    root: {
      display: 'block',
      margin: '0 170px 0 70px'
    },
    link: {
      color: 'black',
      textTransform: 'capitalize'
    }
  }));

  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div>
        <Button variant='outlined'>
          <Link to='/addContact' className={classes.link}>
            <Icon class='fas fa-plus' style={{ color: '#91CFEC' }}></Icon> Add
            Contact
          </Link>
        </Button>
      </div>
      <div>
        <Button>
          <Link to='/actions' className={classes.link}>
            All Contacts
          </Link>
        </Button>
      </div>
      <div>
        <Button>
          <Link to='/addContact' className={classes.link}>
            Starred
          </Link>
        </Button>
      </div>
    </div>
  );
};

export default Contact;



// WEBPACK FOOTER //
// ./src/components/SideBars/Contact.js